exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nav_menu[data-v-a1dc97a4]{\n  margin-bottom: 10px;\n  padding: 5px;\n  border-radius: 5px;\n  background-color: #b3d8fd;\n}\n.main[data-v-a1dc97a4] {\n  width: 100%;\n  padding: 0 20px;\n  box-sizing: border-box;\n}\n", ""]);

// exports
